export default __webpack_public_path__ + "static/media/face-wink.6741552f.svg";